/**
 * Rental Promo Accordion Functionality
 * Handles accordion toggle behavior for accordion rate blocks
 */

class RentalPromoAccordion {
  constructor() {
    this.init();
  }

  init() {
    console.log('RentalPromoAccordion: Initializing...');
    this.bindEvents();
    this.initializeDefaultStates();
    console.log('RentalPromoAccordion: Initialization complete');
  }

  bindEvents() {
    // Bind click events to all accordion triggers
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-accordion-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleAccordion(trigger);
      }
    });

    // Bind keyboard events for accessibility
    document.addEventListener('keydown', (event) => {
      const trigger = event.target.closest('[data-accordion-trigger]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleAccordion(trigger);
      }
    });
  }

  initializeDefaultStates() {
    // Initialize accordions that should be expanded by default
    const expandedAccordions = document.querySelectorAll('.rental-promo__accordion-content--expanded');
    console.log('Found expanded accordions:', expandedAccordions.length);
    
    expandedAccordions.forEach(content => {
      const accordionItem = content.closest('.rental-promo__accordion-item');
      if (accordionItem) {
        this.setAccordionState(accordionItem, true);
      }
    });

    // Also check for all accordion items to ensure they're properly initialized
    const allAccordions = document.querySelectorAll('.rental-promo__accordion-item');
    console.log('Total accordion items found:', allAccordions.length);
  }

  toggleAccordion(trigger) {
    const accordionId = trigger.getAttribute('data-accordion-trigger');
    const accordionItem = trigger.closest('.rental-promo__accordion-item');
    const content = document.querySelector(`[data-accordion-content="${accordionId}"]`);
    
    console.log('Toggling accordion:', { accordionId, accordionItem, content });
    
    if (!accordionItem || !content) {
      console.error('Accordion elements not found for ID:', accordionId);
      return;
    }

    const isExpanded = accordionItem.classList.contains('rental-promo__accordion-item--expanded');
    console.log('Current state:', isExpanded ? 'expanded' : 'collapsed');
    this.setAccordionState(accordionItem, !isExpanded);
  }

  setAccordionState(accordionItem, isExpanded) {
    const content = accordionItem.querySelector('.rental-promo__accordion-content');
    const trigger = accordionItem.querySelector('[data-accordion-trigger]');
    
    if (!content || !trigger) {
      console.warn('Accordion elements not found:', { content, trigger });
      return;
    }

    if (isExpanded) {
      // Expand accordion
      accordionItem.classList.add('rental-promo__accordion-item--expanded');
      content.classList.add('rental-promo__accordion-content--expanded');
      
      // Set ARIA attributes for accessibility
      accordionItem.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    } else {
      // Collapse accordion
      accordionItem.classList.remove('rental-promo__accordion-item--expanded');
      content.classList.remove('rental-promo__accordion-content--expanded');
      
      // Set ARIA attributes for accessibility
      accordionItem.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new RentalPromoAccordion();
  });
} else {
  new RentalPromoAccordion();
}
